<template>
  <div class="user-line">
    <div class="user">
      <UserAvatar
        v-if="profile.user.photo"
        class="tw-shrink-0 lg:tw-w-20 lg:tw-h-20"
        size="base"
        :image-url="profile.user.photo"
        :display-name="profile.user.name || ''"
      />
      <div class="info text-center text-md-left">
        <span v-if="profile.user.name" class="username" :style="{color: titleColor}">{{ profile.user.name }} </span>
        <span v-if="profile.user.title" class="headline" :style="{color: titleColor}">{{ profile.user.title }}</span>
        <span v-if="profile.user.company" class="company_name" :style="{color: titleColor}">{{ profile.user.company }}</span>
        <div v-if="profile.user.summary" class="summary tw-whitespace-break-spaces" :style="{color: titleColor}">{{ profile.user.summary }}</div>
        <div v-if="profile.user.display_socials" class="socials py-2">
          <a v-if="profile.user.linkedin_url" target="_blank" :href="profile.user.linkedin_url" rel="noopener noreferrer">
            <i class="fa-stack fa-1x">
              <i class="fas fa-square mbc-linkedin fa-stack-2x"></i>
              <i class="fab fa-stack-1x fa-linkedin-in fa-inverse"></i>
            </i>
          </a>
          <a v-if="profile.user.facebook_url" target="_blank" :href="profile.user.facebook_url" rel="noopener noreferrer">
            <i class="fa-stack fa-1x">
              <i class="fas fa-square mbc-facebook fa-stack-2x"></i>
              <i class="fab fa-stack-1x fa-facebook fa-inverse"></i>
            </i>
          </a>
          <a v-if="profile.user.twitter_url" target="_blank" :href="profile.user.twitter_url" rel="noopener noreferrer">
            <i class="fa-stack fa-1x">
              <i class="fas fa-square mbc-x-twitter fa-stack-2x"></i>
              <i class="fab fa-stack-1x fa-x-twitter fa-inverse"></i>
            </i>
          </a>
          <a v-if="profile.user.instagram_url" target="_blank" :href="profile.user.instagram_url" rel="noopener noreferrer">
            <i class="fa-stack fa-1x">
              <i class="fas fa-square mbc-instagram fa-stack-2x"></i>
              <i class="fab fa-stack-1x fa-instagram fa-inverse"></i>
            </i>
          </a>
          <a v-if="profile.user.youtube_url" target="_blank" :href="profile.user.youtube_url" rel="noopener noreferrer">
            <i class="fa-stack fa-1x">
              <i class="fas fa-square mbc-youtube fa-stack-2x"></i>
              <i class="fab fa-stack-1x fa-youtube fa-inverse"></i>
            </i>
          </a>
          <a v-if="profile.user.tiktok_url" target="_blank" :href="profile.user.tiktok_url" rel="noopener noreferrer">
            <i class="fa-stack fa-1x">
              <i class="fas fa-square color-tiktok fa-stack-2x"></i>
              <i class="fab fa-tiktok fa-stack-1x fa-inverse"></i>
            </i>
          </a>
        </div>
        <div class="d-flex flex-column text-center text-md-left" :style="{color: titleColor}">
          <div v-if="profile.user.phone" class="text-nowrap" title="Mobile Phone"><i class="fal fa-mobile fa-1x mr-1"></i> {{ profile.user.phone }}</div>
          <div v-if="profile.user.business_phone" class="text-nowrap" title="Business Phone"><i class="fal fa-phone fa-1x mr-1"></i> {{ profile.user.business_phone }}</div>
          <div v-if="profile.user.email" class="text-nowrap" title="Email Address"><i class="fal fa-envelope fa-1x mr-1"></i> <a :href="'mailto:' + profile.user.email">{{ profile.user.email }}</a></div>
          <div v-if="profile.user.web_address" class="text-nowrap" title="Web Address"><i class="fal fa-external-link fa-1x mr-1"></i> <a :href="profile.user.web_address" target="_blank" rel="nofollow noopener noreferrer">{{ profile.user.web_address }}</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/common/user-avatar.vue'

export default {
  name: 'ProfileSignature',
  components: { UserAvatar },
  props: {
    titleColor: {
      type: String,
      required: true
    },
    profile: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.user-line {
  display: flex;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}
.user {
  margin: 10px 0;
  display: flex;
  align-items: flex-start;
  max-width: 100%;
  @media (max-width: 768px) {
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    max-width: 100%;

    @media (min-width: 768px) {
      padding-left: 10px;
    }

    .username {
      font-size: 18px;
    }
    .headline, .company_name {
      font-size: 16px;
    }
    .summary {
      font-size: 14px;
    }
  }

  .socials {
    display: flex;
    align-items: center;
    justify-content: start;
    @media (max-width: 768px) {
      justify-content: center;
    }
    .fa-stack {
      width: 2em;
    }
  }
}

.color {
  &-tiktok {
    color: #2f353b;
  }
}
</style>
